module.exports = __webpack_public_path__ + "img/deployment-2.5ff67b47.jpg";